import type { FC } from 'react';
import { ChipListConnector } from './ChipListConnector';
import { PdpSwatchesList } from './PdpSwatchesList';
import type { Product, ProductVariant } from '../../../../bff-api/products/model';

interface BuyBoxVariantsProps {
    product: Product;
    onChange: (id: string) => void;
    className?: string;
    id?: string;
    filterVariants?: (variants: ProductVariant[]) => ProductVariant[];
    size?: 'small' | 'default';
}

export const BuyBoxVariants: FC<BuyBoxVariantsProps> = ({
    product,
    onChange,
    className,
    id,
    filterVariants,
    size = 'default',
}: BuyBoxVariantsProps) => {
    const { variants, variationAttributes } = product;
    const filteredVariants = filterVariants ? filterVariants(variants) : variants;

    if (filteredVariants?.[0]?.variationValues?.colorName) {
        return (
            <div data-testid={id ?? 'buy-box-variants-swatches-list'} className={className}>
                <PdpSwatchesList
                    variantsList={filteredVariants}
                    variationAttributes={variationAttributes}
                    activeId={product.id}
                    onChange={onChange}
                    size={size}
                />
            </div>
        );
    }

    if (filteredVariants?.[0]?.variationValues?.size) {
        return (
            <div data-testid={id ?? 'buy-box-variants-chip-list'} className={className}>
                <ChipListConnector
                    label={
                        filteredVariants?.[0]?.variationValues?.size.length === 1
                            ? 'Letter'
                            : 'Size'
                    }
                    activeId={product.id}
                    onChange={onChange}
                    chipListItems={filteredVariants}
                    variationAttributes={variationAttributes}
                    size={size}
                />
            </div>
        );
    }

    return null;
};

BuyBoxVariants.defaultProps = {
    className: undefined,
    id: undefined,
    filterVariants: undefined,
    size: 'default',
};
